import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _arrayItems = { number: '_numberType', object: '_objectType' };
var _arrayType = { items: '_arrayItems' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _breakPoint = { items: '_itemLayout' };
var _cloneFormTemplateRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    formTemplate: '_formTemplate',
};
var _cloneFormTemplateResponse = { formTemplate: '_formTemplate' };
var _createFormTemplateRequest = { formTemplate: '_formTemplate' };
var _createFormTemplateResponse = { formTemplate: '_formTemplate' };
var _deleteFormTemplateRequest = {};
var _deleteFormTemplateResponse = {};
var _design = { poll: '_pollDesign' };
var _formField = { validation: '_validation' };
var _formLayout = {
    large: '_breakPoint',
    medium: '_breakPoint',
    small: '_breakPoint',
};
var _formTemplate = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_formField',
    steps: '_step',
    deletedFields: '_formField',
    submitSettings: '_submitSettings',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getFormTemplateRequest = {};
var _getFormTemplateResponse = { formTemplate: '_formTemplate' };
var _group = { items: '_itemLayout' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _item = { image: '_image', video: '_video' };
var _itemLayout = { group: '_group' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listFormTemplatesRequest = {};
var _listFormTemplatesResponse = { templates: '_formTemplate' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _numberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _objectType = { properties: 'Map#_propertiesType' };
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _propertiesType = { number: '_numberType', array: '_arrayType' };
var _queryFormTemplateRequest = {};
var _queryFormTemplateResponse = { formTemplates: '_formTemplate' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _step = { layout: '_formLayout' };
var _submitSettings = { thankYouMessageOptions: '_thankYouMessageOptions' };
var _thankYouMessageOptions = { richContent: '_richContent' };
var _updateFormTemplateRequest = {
    mask: 'google.protobuf.FieldMask',
    formTemplate: '_formTemplate',
};
var _updateFormTemplateResponse = { formTemplate: '_formTemplate' };
var _validation = {
    number: '_numberType',
    array: '_arrayType',
    object: '_objectType',
};
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixFormsTemplatesV1FormTemplateServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/_api/form-templates',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/form-templates',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/form-templates',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/form-templates',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/form-templates',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/_api/form-templates',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
            {
                srcPath: '/form-template-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/form-template-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new form template. */
export function createFormTemplate(payload) {
    var _a = serializer(_createFormTemplateRequest, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFormTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'POST',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.CreateFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFormTemplate.fromReq = fromReq;
    __createFormTemplate.__isAmbassador = true;
    return __createFormTemplate;
}
/** Clones an existing template. */
export function cloneFormTemplate(payload) {
    var _a = serializer(_cloneFormTemplateRequest, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneFormTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __cloneFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'POST',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.CloneFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template/{formTemplateId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneFormTemplate.fromReq = fromReq;
    __cloneFormTemplate.__isAmbassador = true;
    return __cloneFormTemplate;
}
/** Get a form template by id. */
export function getFormTemplate(payload) {
    var _a = serializer(_getFormTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'GET',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.GetFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template/{formTemplateId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFormTemplate.fromReq = fromReq;
    __getFormTemplate.__isAmbassador = true;
    return __getFormTemplate;
}
/**
 * Updates a form template, supports partial update.
 * You need to passes the latest `revision` for a successful update.
 */
export function updateFormTemplate(payload) {
    var _a = serializer(_updateFormTemplateRequest, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFormTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'PATCH',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.UpdateFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template/{formTemplate.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFormTemplate.fromReq = fromReq;
    __updateFormTemplate.__isAmbassador = true;
    return __updateFormTemplate;
}
/** Deletes a form template. */
export function deleteFormTemplate(payload) {
    var _a = serializer(_deleteFormTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFormTemplateResponse, {}).fromJSON;
    function __deleteFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'DELETE',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.DeleteFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template/{formTemplateId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFormTemplate.fromReq = fromReq;
    __deleteFormTemplate.__isAmbassador = true;
    return __deleteFormTemplate;
}
/** Query form templates using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
export function queryFormTemplate(payload) {
    var _a = serializer(_queryFormTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryFormTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryFormTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'POST',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.QueryFormTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/template/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFormTemplate.fromReq = fromReq;
    __queryFormTemplate.__isAmbassador = true;
    return __queryFormTemplate;
}
/** Lists form templates, filtered by namespace and template ids. */
export function listFormTemplates(payload) {
    var _a = serializer(_listFormTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFormTemplatesResponse, {
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _background: _background,
        _breakPoint: _breakPoint,
        _design: _design,
        _formField: _formField,
        _formLayout: _formLayout,
        _formTemplate: _formTemplate,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _propertiesType: _propertiesType,
        _richContent: _richContent,
        _step: _step,
        _submitSettings: _submitSettings,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __listFormTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v1.form_template',
            method: 'GET',
            methodFqn: 'wix.forms.templates.v1.FormTemplateService.ListFormTemplates',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsTemplatesV1FormTemplateServiceUrl({
                protoPath: '/v1/templates',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFormTemplates.fromReq = fromReq;
    __listFormTemplates.__isAmbassador = true;
    return __listFormTemplates;
}
//# sourceMappingURL=http.impl.js.map